import React, { useEffect } from 'react';
import { Alert, Card, CardBody, Col, Container, Row } from 'shards-react';
import LoginForm from '../components/login/LoginForm';
import LanguageSelector from '../components/common/LanguageSelector';
import ResetLink from '../components/login/ResetLink';
import LoginInfo from '../components/login/LoginInfo';
import InformationMessage from '../components/login/InformationMessage';
import { signOut } from '@aws-amplify/auth';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { getInformations, resetServerMessage } from '../redux/slices/information';

const Login = (): React.ReactElement => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { informations } = useSelector((state: RootState) => state.information);
  const informationHasError = useSelector((state: RootState) => state.information.hasError);
  const informationServerMessage = useSelector((state: RootState) => state.information.serverMessage);
  const { isLoading, serverMessage, login } = useSelector((state: RootState) => state.session);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log();
  // }, []);

  // /**
  //  * 強制サインアウト
  //  * お知らせ取得
  //  */
  useEffect(() => {
    (async () => {
      await signOut();
    })();
    dispatch(getInformations());
  }, []);

  // 認証できたら検索画面へリダイレクトする
  useEffect(() => {
    if (login) {
      const pushTo = location.search.length ? location.search.split('?r=')[1] : '/mill-sheet-search';
      history.push(pushTo);
    }
  }, [login]);

  // EVENT HANDLER
  // ================================================================================

  /**
   * メッセージを消す
   */
  const dismiss = (): void => {
    dispatch(resetServerMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <>
      {/* お知らせのサーバメッセージ表示 */}
      <InformationMessage hasError={informationHasError} message={informationServerMessage} onDismiss={dismiss} />

      <Container fluid className="main-content-container h-100 px-4">
        <Row className="py-3">
          <Col className="d-flex justify-content-end">
            <LanguageSelector />
          </Col>
        </Row>
        <Row noGutters className="mt-5">
          <Col id="loginWrapperCol" className="auth-form mx-auto my-auto">
            <Row>
              <Col lg="3" md="5" className="auth-form mx-auto my-auto">
                <Card>
                  <CardBody>
                    <img className="auth-form__logo d-table mx-auto mb-3" src={`${process.env.PUBLIC_URL}/images/logo_timss_long-3.png`} alt="Mill Sheet Search System - Login" />

                    <div id="message" className="pb-1">
                      <Alert theme="primary" open={serverMessage !== undefined}>
                        {isLoading ? 'Loading...' : serverMessage}
                      </Alert>
                    </div>

                    <LoginForm />
                  </CardBody>
                </Card>

                <ResetLink linkText={t('login.goToResetPassword')} />
              </Col>
            </Row>

            {informations && <LoginInfo title={t('login.information')} informations={informations} />}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
